<template>
    <v-container fill-height class="align-start">
        <div class="row no-gutters" width="100%">
            <v-col>
                <v-toolbar
                    class="elevation-0 mt-n3 row-full py-0"
                    height="relative"
                >
                    <div class="container d-flex align-center py-1">
                        <v-toolbar-title
                            color="primary"
                            class="headline font-weight-bold"
                            style="line-height: 36px"
                        >
                            Help Center: How-To Videos
                        </v-toolbar-title>
                    </div>

                    <template v-slot:extension>
                        <div class="container d-lg-flex py-4">
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        single-line
                                        label="Search..."
                                        v-model="searchText"
                                        outline
                                        style="width: 100%"
                                        clearable
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </div>
                    </template>
                </v-toolbar>

                <v-row class="pt-3 mt-24" v-if="filteredVideos.length">
                    <template v-for="(video, i) in filteredVideos">
                        <v-col sm="6" md="6" lg="4" class="col-12 px-3 px-lg-4" :key="i">
                            <v-card class="mx-auto my-3" max-width="400" height="400">
                                <video controls style="width: 100%; min-height: 200px;">
                                    <source :src="video.src" type="video/mp4">
                                    Sorry, your browser doesn't support embedded videos.
                                </video>
                                <v-card-title class="subtitle-1 font-weight-bold pb-2" style="line-height: 1.2; word-break: break-word;">
                                    {{ video.title }}
                                    <template v-if="video.text">
                                        <br />
                                        {{ video.text }}
                                    </template>
                                </v-card-title>

                                <v-card-text>
                                    <div>
                                        <ol v-if="video.steps" class="pl-4">
                                            <template v-for="(step, j) in video.steps.slice(0, 3)">
                                            <li :key="j">{{ step }}</li>
                                            </template>
                                        </ol>
                                    </div>

                                    <div>
                                        <v-btn absolute right text bottom color="primary" @click.prevent="showVideoModal(video)">
                                            Read More
                                        </v-btn>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </template>
                </v-row>

                <div class="pt-6 mt-24 text-center" v-else>
                    <v-img src="/images/not-found.png" class="mx-auto my-5" max-height="200" max-width="150" />
                    <h1 class="title font-weight-bold">No videos found</h1>
                </div>
            </v-col>
        </div>

        <video-modal
            :show="showVideo"
            @close="closeVideoModal"
            v-if="selectedVideo"
            :video="selectedVideo"
        />
    </v-container>
</template>

<script>
    import videoModal from './components/video-modal.vue';
    import videos from '../modules/videos';

    export default {
        components: { videoModal },
        data() {
            return {
                showVideo: false,
                selectedVideo: null,
                searchText: null,
                videos,
            };
        },
        computed: {
            filteredVideos() {
                const searchText = (this.searchText || '').toLowerCase();
                const countryAbbreviation = this.$_user.country_abbreviation;

                return this.videos.filter((video) => {
                    if (video.country && video.country !== countryAbbreviation) {
                        return false;
                    }

                    let {
                        title,
                        text,
                    } = video;

                    title = (title || '').toLowerCase();
                    text = (text || '').toLowerCase();

                    return title.includes(searchText) || text.includes(searchText);
                });
            },
        },
        methods: {
            showVideoModal({
                title, text, src, steps,
            }) {
                const videoTitle = `${title} ${text ? `- ${text}` : ''}`;
                this.selectedVideo = {
                    title: videoTitle,
                    src,
                    steps,
                };
                this.showVideo = true;
            },
            closeVideoModal() {
                this.showVideo = false;
                this.selectedVideo = null;
            },
        },
    };
</script>

<style scoped>
.v-toolbar__extension {
    height: 75px !important;
}
</style>
